export default __webpack_public_path__ + "static/media/parfit.67ef5df5.svg";